import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setShipmentAppointmentTypes } from '../common/CommonActions';
import { getShipmentAppointmentTypes } from '../shipment/ShipmentEffects';

const useShipmentAppointmentList = () => {
  const [list, setList] = useState(undefined);
  const { shipmentAppointmentTypes } = useSelector((state) => state.common);
  const dispatch = useDispatch();

  useEffect(() => {
    if (shipmentAppointmentTypes.success) {
      setList(shipmentAppointmentTypes.data);
    } else {
      getList();
    }
  }, [shipmentAppointmentTypes]);

  const getList = async () => {
    try {
      dispatch(setShipmentAppointmentTypes({ success: true, data: [] }));
      const { data } = await getShipmentAppointmentTypes();
      setList(data);
      dispatch(setShipmentAppointmentTypes({ success: true, data }));
    } catch (error) {
      setList([]);
    }
  };

  return list;
};

export default useShipmentAppointmentList;
